/**通知**/

<template>
  <div class="inform">
    <div class="informContent">
      <pull-to v-if="content.length>0" :bottom-load-method="bottomChangeFn" :top-load-method="topChangeFn">
        <ul>
          <xk-inform-time-mod :time="item?item.created:null"
                              :content="item?item.content:null"
                              v-for="(item, index) in content"
                              :key="index">
          </xk-inform-time-mod>
        </ul>
      </pull-to>
      <div v-else="" class="wujilv">
        <h2>暂无消息通知</h2>
      </div>
    </div>
  </div>
</template>

<script>
  import XkInformTimeMod from '../module/informTimeMod/src/informTimeMod'
  import { mapGetters } from 'vuex'
  import PullTo from 'vue-pull-to'

  export default {
    components: {XkInformTimeMod, PullTo},
    name: 'Inform',
    computed: {
      ...mapGetters({
        loginData: 'loginData'
      })
    },
    data () {
      return {
        page: 1,
        rows: 10,
        content: []
      }
    },
    methods: {
      loadDataButFn: function (fn, type) {
        let that = this
        that.$store.dispatch('getNotice', {
          'passengerId': that.loginData.passenger.id,
          'page': that.page,
          'limit': that.rows,
          fn (data) {
            if (fn) {
              fn()
            }
            if (data && data.code === 1) {
              if (type) {
                that.content = data.noticeRecords || []
              } else {
                that.content = [...that.content, ...data.noticeRecords]
              }
            }
          }
        })
      },
      bottomChangeFn (loaded) { // 上拉刷新
        this.page++
        this.loadDataButFn(() => {
          loaded('done')
        })
      },
      topChangeFn (loaded) { // 下拉刷新
        this.page = 1
        this.loadDataButFn(() => {
          loaded('done')
        }, true)
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.loadDataButFn()
          // that.$store.dispatch('updateLoginData', {passengerId: that.loginData.passenger.id})
          // if (that.imformNum.content !== '') {
          //   // that.$store.dispatch('upImformNum', {
          //   //   'passengerId': that.loginData.passenger.id,
          //   //   'noticeIds': that.imformNum.content
          //   // })
          // }
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">

  .inform {
    background: #f3f4f5;
    height: 100vh;
    width: 100vw;
    .informContent {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      ul {
        margin-bottom: 1rem;
      }
      .wujilv {
        height: 40vh;
        padding-top: 30vh;
        h2 {
          text-align: center;
        }
      }
    }
    .loadDataBut {
      box-sizing: border-box;
      width: 100%;
      line-height: 3.5rem;
      padding: 0 1rem;
      margin-bottom: 1rem;
      span {
        width: 100%;
        background-color: #fff;
        border-radius: 0.333rem;
        text-align: center;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// inform.vue?01ff53ab